module.exports = __webpack_public_path__ + "img/SaudiArabia.3ed6fc31.webp";